import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: "continue-button-wrapper",
  class: "continue-button-wrapper"
}

import Dictionary from "~/ts/library/Dictionary";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatFormInput from "~/chat/vue/widget/form/ChatFormInput.vue";
import {IChatFormNextStep} from "~/chat/vue/widget/form/Interface";
import ObjectHelper from "~/ts/library/ObjectHelper";
import {COLLECT_CONTACT_FIELD_REQUIRED} from "~/chat/ts/data/ISiteParams";
import {ClientStore} from "~/chat/ts/store/Client";
import {CLIENT_CAPTCHA_FIELD_NAME, CLIENT_DATA_TYPE_EULA} from "~/chat/ts/data/IClient";
import ChatFormItem from "~/chat/vue/widget/form/ChatFormItem.vue";
import ChatFormButton from "~/chat/vue/widget/form/fields/ChatFormButton.vue";
import ChatApiResult from "~/chat/ts/service/request/ChatApiResult";
import {__} from "~/ts/library/Translate";
import {IField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {WidgetStore} from "~/chat/ts/store/Widget";
import {computed, getCurrentInstance, nextTick, onMounted, ref, watch} from "vue";
import useObjectModel from "~/ts/vuePlugins/useObjectModel";
import {ChatFormInputInterface} from "~/chat/vue/widget/form/fields/useChatFormInput";
import ChatFormButtonColorInterface from "~/chat/vue/widget/form/fields/ChatFormButtonColorInterface";


const __default__ = {
    name: "ChatForm"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    form: {},
    step: { type: Boolean },
    steppedCardDisplay: { type: Boolean, default: true },
    displayAllSteps: { type: Boolean, default: false },
    showLoad: { type: Boolean },
    useStoredValues: { type: Boolean, default: true },
    fields: {},
    button: {},
    eula: { type: Boolean, default: true },
    buttonColor: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["fill-change", "next-step", "apply"], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let displayedFieldsCount = ref(1);

let isShowEula = computed(() => {
    return props.eula && WidgetStore.isEulaEnabled.value;
});

let computedForm = computed(() => {
    let result: Dictionary<number> = {...props.form};
    let captcha = !!result.captcha;
    delete result.captcha;
    if (isShowEula.value) {
        result[CLIENT_DATA_TYPE_EULA] = COLLECT_CONTACT_FIELD_REQUIRED;
    }
    if (captcha) {
        result[CLIENT_CAPTCHA_FIELD_NAME] = 2;
    }
    return result;
});


let fieldsKeys = computed(() => {
    return ObjectHelper.getKeys(computedForm.value);
});


let defaultModelValue = computed(() => {
    let result: Dictionary<any> = {};
    for (let key of fieldsKeys.value) {
        let value = null;
        if (props.useStoredValues) {
            value = ClientStore.getFieldValue(key);
        }
        result[key] = value != null ? value : null;
    }
    if (isShowEula.value) {
        result.needEulaAgreement = 1;
    }
    return result;
});
let initialModelValue = ObjectHelper.jsonClone(defaultModelValue.value);

let error = ref<IField[]>([]);


let computedFieldsDictionary = computed(() => {
    return props.fields ? props.fields : ConfigStore.siteParams.value.formElements;
});

let fieldsList = computed(() => {
    let result = [];
    let clientDataKeys = computedFieldsDictionary.value;
    for (let fieldName of fieldsKeys.value) {
        if (clientDataKeys[fieldName]) {
            result.push(clientDataKeys[fieldName]);
        }
    }
    return result;
});


let fieldsCount = computed(() => {
    return fieldsList.value.length;
});

function init() {
    displayedFieldsCount.value = props.displayAllSteps ? fieldsCount.value : 1;
    if (props.useStoredValues) {
        checkFilledFields();
    }
}

let _modelValue = _useModel<Dictionary<any>>(__props, "modelValue");
let model = useObjectModel(_modelValue, () => {
    return ObjectHelper.jsonClone(initialModelValue);
}, () => init());


//let model = ref<Dictionary<any>>({});



function checkFilledFields() {
    let index = 0;
    for (let key of fieldsKeys.value) {
        if (isFieldFilled(key) && isLastDisplayedInput(index)) {
            showOneMoreInput();
            break;
        }
        index++;
    }
}

function isFieldRequired(id: string) {
    return computedForm.value[id] === COLLECT_CONTACT_FIELD_REQUIRED;
}

function isFieldFilled(id: string) {
    let value = _modelValue.value ? _modelValue.value[id] : null;
    let result = value != null;
    if (result && typeof value == "string" && !value.length) {
        result = false;
    }
    return result;
}

onMounted(() => {
    emitFilled();
});


function emitFilled() {
    emits("fill-change", isAllRequiredFieldsFilled.value);
}

let displayedFieldsList = computed(() => {
    let result = fieldsList.value;
    if (props.step) {
        result = result.filter((field, index) => index < displayedFieldsCount.value);
    }
    return result;
});

let emptyRequiredFields = computed(() => {
    return getEmptyRequiredFields(fieldsList.value);
});

function getEmptyRequiredFields(fieldsList: IField[]) {
    return fieldsList.filter(field => {
        return isFieldRequired(field.name) && !isFieldFilled(field.name);
    });
}

let isAllRequiredFieldsFilled = computed(() => {
    return emptyRequiredFields.value.length == 0;
});

let isAllVisibleRequiredFieldsFilled = computed(() => {
    return getEmptyRequiredFields(displayedFieldsList.value).length == 0;
});



function showOneMoreInput() {
    if (displayedFieldsCount.value < fieldsCount.value) {
        displayedFieldsCount.value++;
        checkFilledFields();
    }
}

function isLastDisplayedInput(index: number): boolean {
    return index == displayedFieldsCount.value - 1;
}

let continueButtonText = computed(() => {
    if (displayedFieldsCount.value != fieldsCount.value || !props.button) {
        return __("CONTINUE");
    } else {
        return props.button;
    }
});

let instance = getCurrentInstance().proxy;

let input = ref<ChatFormInputInterface[]>();


function onContinue(index?: number, buttonClick?: boolean) {
    if (isAllVisibleRequiredFieldsFilled.value) {
        if (displayedFieldsCount.value != fieldsCount.value) {
            if (index == null || isLastDisplayedInput(index)) {
                let height = (instance.$el as HTMLElement).offsetHeight;
                showOneMoreInput();
                nextTick(() => {
                    let inputs = input.value;
                    let lastInput = inputs ? inputs[inputs.length - 1] : null;
                    if (lastInput) {
                        lastInput.focus();
                    }
                    emits('next-step', {
                        deltaHeight: (instance.$el as HTMLElement).offsetHeight - height,
                        lastInput
                    } as IChatFormNextStep);
                });
            }
        } else if (buttonClick) {
            emitApply();
        }
    }
}

function onApply() {
    error.value = [];

    if (isAllRequiredFieldsFilled.value) {
        emitApply();
    } else {
        let empty = error.value = emptyRequiredFields.value;
        let names = empty.map(field => field.placeholder ? field.placeholder : field.descr);
        (new ChatApiResult({
            code: 0,
            descr: `<p>${__("REQUIRED_FOR_FILL")}:</p><ul class="simple-list"><li>${names.join("</li><li>")}</li></ul>`
        })).showMessage(instance, false);


    }
}

function emitApply() {
    emits("apply", ObjectHelper.jsonClone(model.value));
}


watch(defaultModelValue, () => {
    let defaultModel = defaultModelValue.value;
    for (let key in defaultModel) {
        if (defaultModel.hasOwnProperty(key)) {
            if (defaultModel[key] != initialModelValue[key]) {
                if (initialModelValue[key] === model.value[key]) {
                    model.value[key] = initialModelValue[key] = defaultModel[key];
                }
            }
        }
    }
})
watch(computed(() => props.fields), () => init());
watch(computed(() => props.step), () => init());
watch(isAllRequiredFieldsFilled, () => emitFilled());


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['chat-form', _ctx.step && _ctx.steppedCardDisplay ? 'stepped' : 'full'])
  }, [
    _renderSlot(_ctx.$slots, "prepend"),
    _createVNode(_TransitionGroup, {
      name: "list",
      tag: "span"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedFieldsList), (field, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: field.name
          }, [
            (field.type === 'eulaAgreement')
              ? _renderSlot(_ctx.$slots, "before-eula-or-append", { key: 0 })
              : _createCommentVNode("", true),
            _createVNode(ChatFormItem, {
              class: _normalizeClass(['chat-form-item', `name-${field.name}`, index === _unref(displayedFieldsList).length - 1 ? 'last' : null])
            }, {
              default: _withCtx(() => [
                _createVNode(ChatFormInput, {
                  error: _unref(error).indexOf(field) > -1,
                  field: field,
                  modelValue: _unref(model)[field.name],
                  "onUpdate:modelValue": ($event: any) => ((_unref(model)[field.name]) = $event),
                  required: isFieldRequired(field.name),
                  onContinue: ($event: any) => (onContinue(index)),
                  ref_for: true,
                  ref_key: "input",
                  ref: input
                }, null, 8, ["error", "field", "modelValue", "onUpdate:modelValue", "required", "onContinue"])
              ]),
              _: 2
            }, 1032, ["class"])
          ]))
        }), 128)),
        (_ctx.step)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(ChatFormButton, {
                type: "primary",
                inverse: "",
                disabled: !_unref(isAllVisibleRequiredFieldsFilled),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onContinue(null, true))),
                "show-load": _ctx.showLoad,
                class: "w-100 text-center continue"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(continueButtonText)), 1)
                ]),
                _: 1
              }, 8, ["disabled", "show-load"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    (!_unref(isShowEula))
      ? _renderSlot(_ctx.$slots, "before-eula-or-append", { key: 0 })
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "append"),
    (_ctx.button && !_ctx.step)
      ? (_openBlock(), _createBlock(ChatFormButton, {
          key: 1,
          class: _normalizeClass({
                'primary button': true,
                'full-width': !_ctx.$slots.append
            }),
          onClick: onApply,
          "show-load": _ctx.showLoad,
          round: "",
          color: _ctx.buttonColor
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.button), 1)
          ]),
          _: 1
        }, 8, ["class", "show-load", "color"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})